var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('VToastVue',{ref:"vtoast"}),_c('VLoadingVue',{ref:"vloading"}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }